<template>
  <div class="cgt-hero-item flex flex-column fit-content">
    <div class="icon flex flex-row items-center mb-12">
      <img class="mr-8" :src="data.icon" :alt="data.content" />

      <div class="bd-t-1 wp-100 bd-white"></div>
    </div>
    <div class="cgt-hero-item-content white">
      <h2 class="fw-700 lh-28 fs-24">{{ data.title }}</h2>
      <p class="mb-0 fw-500 lh-28 fs-18 ls-1">{{ data.content }}</p>
    </div>
  </div>
</template>

<script setup>
import {assetCDN} from '~/helper/index.js'
const ASSETS_CDN = assetCDN()
defineProps({
  data: {
    type: Object,
    default: () => {
      return {
        title: '',
        content: '',
        icon: `${assetCDN()}/icons/arrow_outward.svg`,
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.bd-white {
  opacity: 0.35;
}
</style>
